module.exports = __webpack_public_path__ + "static/media/min.e995da6c.svg";